(function () {

    'use strict';

    angular.module('iplusjs.utils.formField', [
        'lodash',
        'iplusjs.utils.misc',
        'iplusjs.utils.device',
        'iplusjs.utils.html'
    ])
        .service('FormFieldUtilsService', FormFieldUtilsService);

    FormFieldUtilsService.$inject = [
        '$parse',
        '$window',
        '$timeout',
        'lodash',
        'MiscUtilsService',
        'HtmlUtilsService',
        'DeviceUtilsService'
    ];
    function FormFieldUtilsService($parse, $window, $timeout, _, MiscUtilsService, HtmlUtilsService, DeviceUtilsService) {
        var that = this;

        that.handlePending = handlePending;
        that.renderViewValues = renderViewValues;
        that.renderViewValue = renderViewValue;
        that.resetValue = resetValue;
        that.setValidity = setValidity;
        that.setFormValidity = setFormValidity;
        that.focusFirstInvalid = focusFirstInvalid;
        that.focusInvalid = focusInvalid;
        that.validate = validate;
        that.setControlsSubmitted = setControlsSubmitted;
        that.isValid = isValid;
        that.getFormControls = getFormControls;
        that.resetSubmitted = resetSubmitted;
        that.getFormFieldsErrorObject = getFormFieldsErrorObject;
        that.isSubmitEvent = isSubmitEvent;

        function handlePending(form, pendingKey, pending) {
            if (pending) {
                _.set(form, '$pending.' + pendingKey, [true]);
            } else {
                _.unset(form, '$pending.' + pendingKey);
            }
        }
        function renderViewValues($ngModels) {
            _.each($ngModels, function ($ngModel) {
                renderViewValue($ngModel);
            });
        }
        function renderViewValue($ngModel) {
            var viewValue = $ngModel.$$rawModelValue;

            _.forEachRight($ngModel.$formatters, function (formatter) {
                viewValue = formatter(viewValue);
            });

            $ngModel.$setViewValue(viewValue);
            $ngModel.$render();
        }
        function resetValue($scope, modelExpression, value) {
            var model = $parse(modelExpression);
            model.assign($scope, MiscUtilsService.isEmpty(value) ? null : value);
        }
        function setValidity(fieldItems, validationName, valid) {
            _.each(fieldItems, function (item) {
                if (item) {
                    if (item.$elem && item.$elem[0]) {
                        item.$elem[0].setAttribute('aria-invalid', !valid);
                    }
                    if (_.isFunction(item.$setValidity)) {
                        item.$setValidity(validationName, valid);
                    } else if (item.$ngModel && _.isFunction(item.$ngModel.$setValidity)) {
                        item.$ngModel.$setValidity(validationName, valid);
                    }
                }
            });
        }
        function setFormValidity(form, validationName, valid) {
            if (!form || !validationName) {
                return;
            }
            try {
                form.$setValidity(validationName, valid);
            } catch (error) {
            }
        }
        function focusFirstInvalid($elem, selector) {
            var firstInvalid = $elem[0].querySelector(selector || '.ng-invalid:not(form):not([type=hidden])');

            if ((!firstInvalid || firstInvalid)) {
                if ((firstInvalid && firstInvalid.checkVisibility && !firstInvalid.checkVisibility()) || !firstInvalid) {
                    firstInvalid = $elem[0].querySelector('.validation-message span.error');
                }
            }

            function doFocus() {
                if (firstInvalid) {
                    firstInvalid.focus();

                    if (_.isFunction(firstInvalid.scrollIntoViewIfNeeded)) {
                        firstInvalid.scrollIntoViewIfNeeded();
                    } else if (_.isFunction(firstInvalid.scrollIntoView)) {
                        firstInvalid.scrollIntoView();
                    }
                }
            }
            if (firstInvalid) {
                doFocus();

            } else if (!firstInvalid) {
                firstInvalid = $elem[0].querySelector('.validation-message .error');

                doFocus();
            }
        }
        function focusInvalid($elem) {
            var invalid = $elem[0];

            function doFocus() {
                if (invalid) {
                    invalid.focus();

                    if (_.isFunction(invalid.scrollIntoViewIfNeeded)) {
                        invalid.scrollIntoViewIfNeeded();
                    } else if (_.isFunction(invalid.scrollIntoView)) {
                        invalid.scrollIntoView();
                    }
                }
            }
            if (invalid) {
                doFocus();

            }
        }
        function validate(form, formFieldName, options) {
            options = options || {};

            var validationElement;

            if (MiscUtilsService.isEmpty(form)) {
                return;
            }

            validationElement = getFormFields(form, formFieldName);

            if (options.setIsSubmitted && angular.isFunction(form.$setSubmitted)) {
                form.isSubmitted = true;
                form.$setSubmitted();
            }

            _.each(_.flatten([validationElement]), function (validationEl) {
                if (validationEl && _.isFunction(validationEl.$validate)) {
                    validationEl.$validate();

                    if (options.setTouched && _.isFunction(validationEl.$setTouched)) {
                        validationEl.$setTouched();
                    }

                    if (options.setIsSubmitted) {
                        validationEl.isSubmitted = true;

                        if (validationEl.$$controls) {
                            that.setControlsSubmitted(validationEl.$$controls);
                        }
                    }

                    if (!validationEl.$valid) {
                        $timeout(function () {
                            focusFirstInvalid(form.$$element);
                        }, 0);
                    }
                }
            });
        }
        function setControlsSubmitted(controls) {
            _.forEach(controls, function (formControl) {
                if (formControl.$$controls) {
                    that.setControlsSubmitted(formControl.$$controls);
                } else {
                    if (_.isObject(formControl) && formControl.hasOwnProperty('$modelValue') && formControl.$$element) {
                        if (formControl.$$element.hasClass && formControl.$$element.hasClass('is-hidden')) {
                            return;
                        }

                        formControl.isSubmitted = true;
                    }
                }
            });
        }

        function isValid(form, formFieldName) {
            var validationElement,
                valid = true;

            validationElement = getFormFields(form, formFieldName);

            _.each(_.flatten([validationElement]), function (validationEl) {
                if (validationEl) {
                    valid = !!validationEl.$valid;
                }

                if (valid === false) {
                    return false;
                }
            });

            return valid;
        }
        function getFormControls(form, formFieldName) {
            if (!form || !_.isFunction(form.$getControls)) {
                return [];
            }

            return _.filter(form.$getControls(), ['$name', formFieldName]);
        }
        function getFormFields(form, formFieldName) {
            var formFields;

            if (!formFieldName) {
                formFields = form;
            } else if (_.isRegExp(formFieldName)) {
                formFields = _.map(_.filter(_.keys(form), function (key) {
                    return formFieldName.test(key);
                }), function (elName) {
                    return form[elName];
                });
            } else if (_.isArray(formFieldName)) {
                formFields = _.map(_.filter(_.keys(form), function (key) {
                    return _.includes(formFieldName, key);
                }), function (elName) {
                    return form[elName];
                });
            } else {
                formFields = form[formFieldName];
            }

            return formFields;
        }

        function resetSubmitted(form, formFieldName) {
            var controls;

            if (!form || !_.isFunction(form.$getControls)) {
                return;
            }

            if (_.isArray(formFieldName)) {
                controls = getFormControls(form, formFieldName);
            } else {
                controls = form.$getControls();
            }

            _.forEach(controls, function (control) {
                if (control) {
                    control.isSubmitted = false;
                }
            });

            form.$setUntouched();
            form.$setPristine();
            form.$submitted = form.isSubmitted = false;
        }
        function getFormFieldsErrorObject(form, formFieldName) {
            if (MiscUtilsService.isAtLeastOneEmpty(form, formFieldName)) {
                return null;
            }

            var formFields = getFormFields(form, formFieldName);

            return _.compact(_.map(formFields, function (formField) {
                var formFieldErrorObject = _.get(formField, '$error');

                if (MiscUtilsService.isNotEmpty(formFieldErrorObject)) {
                    return formFieldErrorObject;
                } else {
                    return;
                }
            }))[0];
        }
        function isSubmitEvent(event) {
            if (!event) {
                return false;
            }

            var relatedTarget = _.get(event, 'relatedTarget') || {};

            return (
                (
                    _.toLower(event.type) === 'blur' &&
                    _.toLower(relatedTarget.tagName) === 'button' &&
                    _.toLower(relatedTarget.type) === 'submit'
                ) || (
                    _.toLower(event.type) === 'keydown' &&
                    (
                        event.keyCode === 13 ||
                        event.code === 'Enter'
                    )
                )
            );
        }
    }

})();
